import { render } from "./DropdownItem.vue?vue&type=template&id=69112e76"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"
script.render = render

export default script